// extracted by mini-css-extract-plugin
export default {"panel-rule":"_2F4vw5H5XYfhTBOR9E0Fca","panel-rule--large":"Bl9O-kBx5HwXrBBLx-5Xn"};